/**
 * Checks whether a URL points to an authenticated proxy/media endpoint.
 * These URLs must be fetched with auth headers instead of direct <img src>.
 */
export function isProxyUrl(url) {
  if (!url || typeof url !== "string") return false;

  return (
    url.includes("/media/proxy") ||
    url.includes("/api/media/download") ||
    url.includes("/graphics/proxy") ||
    url.includes("/cdn/")
  );
}

